export const RECEIVED_REPORT_RUNS = 'reports/RECEIVED_REPORT_RUNS';
export const ERROR_RECEIVED = 'reports/ERROR_RECEIVED';
